import { Breadcrumbs, ButtonLink } from "@sembark-travel/ui/router"
import { generatePath, useLocation } from "../../.../../../../../router-utils"
import { Helmet } from "react-helmet-async"
import { Icons } from "@sembark-travel/ui/base"
import { TSPCreateNewSheetWithInFolder } from "../../../../../DataDrive/TransportService"
import { TSheetFolder } from "../../../../../../src/DataDrive"

export default function TransportServicePricesNewPage() {
	const location = useLocation()
	const folderDetails: TSheetFolder | undefined = location.state?.folderDetails
	return (
		<>
			<Helmet>
				<title>New Transport Service Prices</title>
			</Helmet>
			<Breadcrumbs
				key={"New Transport Service Prices"}
				title="New Transport Service Prices"
				items={[
					[generatePath("/data-drive"), "Data Drive"],
					["", "Transport Sheet"],
				]}
				actions={
					<ButtonLink
						to={generatePath(
							"/data-drive/folders/upload-prices/transport-sheets"
						)}
						level="primary"
						state={{ folderDetails: folderDetails }}
					>
						<Icons.Upload />
						Upload Via CSV
					</ButtonLink>
				}
			/>
			<TSPCreateNewSheetWithInFolder folderDetails={folderDetails} />
		</>
	)
}
